import axios from "axios";
import { apiOrigin } from "./apiOrigin";
import { configureApiClient } from "./configureApiClient";

const api = axios.create({
  baseURL: `${apiOrigin}/api`,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

configureApiClient(api);

export default api;
